<div class="card-footer">
  <div>
    <span class="warning-form" *ngIf="resourceForm?.dirty">* alterações pendentes.</span>
  </div>

  <nav aria-label="Navegar pelos registros" *ngIf="resourceIdList.length > 0">
    <ul class="pagination">
      <li class="page-item" (click)="previous($event)" title="Registro Anterior"
        [ngClass]="position() === 1 ? 'disabled' : ''"
      >
        <a class="page-link" aria-label="Anterior">
          <i class="fas fa-chevron-left"></i>
          <!-- <span aria-hidden="true">&laquo;</span> -->
        </a>
      </li>
      <li class="page-item" style="cursor: default;">
        <a class="page-link">{{position()}} de {{resourceIdList.length}} </a>
      </li>
      <li class="page-item" (click)="next($event)" title="Próximo Registro"
        [ngClass]="position() === resourceIdList.length ? 'disabled' : ''"
      >
        <a class="page-link" aria-label="Próximo">
          <i class="fas fa-chevron-right"></i>
          <!-- <span aria-hidden="true">&raquo;</span> -->
        </a>
      </li>
    </ul>
  </nav>
</div>
